import { Pipe, PipeTransform } from '@angular/core';
import { DropDownItem } from '../../../models/shared/stylesheet/drop-down-item';

/**
 * Builds the DOM id of an option so the combobox can point `aria-activedescendant` at it. The id is
 * keyed on the item's position in the full `dropdowns` list, which stays stable across grouping and
 * the optional Reset row.
 */
@Pipe({
  name: 'dropdownOptionId',
  standalone: true
})
export class DropdownOptionIdPipe implements PipeTransform {
  public transform(
    item: DropDownItem | 'reset' | null | undefined,
    listboxId: string,
    dropdowns: readonly DropDownItem[]
  ): string | null {
    if (!item) return null;
    if (item === 'reset') return `${listboxId}-reset`;
    const index = dropdowns.indexOf(item);
    return index === -1 ? null : `${listboxId}-option-${index}`;
  }
}
